import { FormikModal } from './FormikModal';

export default FormikModal;
